<template>
  <div class="mylayout">
    <el-form class="myform" :model="form" ref="ruleFormRef" label-position="right" label-width="64px">
      <p style="margin: 0px 0px 10px 0px;">单点</p>
      <!--##################################################################-->
      <el-form-item prop="timetype" style="margin-left: -54px">
        <el-radio-group v-model="form.timetype">
          <el-radio label="y-m-d" border style="margin-left: 8px; padding: 5px 15px; 
                    border-width: 1.5px;">Y-M-D</el-radio>
          <el-radio label="y-doy" border style="margin-left: 10px; padding: 5px 15px; 
                    border-width: 1.5px;">Y-DOY</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Y-M-D" prop="ymd">
        <el-date-picker v-model="form.ymd" type="date" :disabled="form.timetype == 'y-m-d' ? false : true" editable
                        placeholder="2020-01-01" :disabled-date="disabledDate"></el-date-picker>
      </el-form-item>

      <el-form-item label="Y-DOY" prop="year">
        <el-input-number v-model="form.year" :disabled="form.timetype == 'y-doy' ? false : true" :min="2003" :max="2022"
          :step="1" step-strictly placeholder="2020" style="width: 160px;" @change="checkyear" />
      </el-form-item>

      <el-form-item label="" prop="doy">
        <el-input-number v-model="form.doy" :disabled="form.timetype == 'y-doy' ? false : true" :min="1"
          :max="form.max_day" :step="1" step-strictly placeholder="1" style="width: 160px;" @change="checkdoy" />
      </el-form-item>
      <!--##################################################################-->
      <el-form-item prop="hourtype" style="margin-left: -54px">
        <el-radio-group v-model="form.hourtype">
          <el-radio label="ut" border style="margin-left: -2px; padding: 3px 32px; 
                    border-width: 1.5px;">UT</el-radio>
          <el-radio label="lt" border style="margin-left: 10px; padding: 3px 32px; 
                    border-width: 1.5px;">LT</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--##################################################################-->
      <el-form-item label="Geog.Lat" prop="lat" style="margin-left: 20px;">
        <el-input-number v-model="form.lat" :min="-87.5" :max="87.5" :step="2.5" step-strictly />
      </el-form-item>

      <el-form-item label="Geog.Lon" prop="lon" style="margin-left: 20px;">
        <el-input-number v-model="form.lon" :min="-180" :max="180" :step="5" step-strictly />
      </el-form-item>
      <!--##################################################################-->
      <el-button @click="onSubmit" style="margin-left: 0px;">Submit</el-button>
      <el-button @click="reset" style="margin-left: 12px;">Reset</el-button>
      <!--##################################################################-->
    </el-form>
    <!--##################################################################-->
    <div class="mycharts" id="ECharts_Single"></div>
    <!--##################################################################-->
  </div>
</template>




<script setup>
import * as echarts from 'echarts';
import { ref, onMounted, toRaw } from 'vue'
import axios from '../util/require'
// -------------------------------------------------------------------------- //
// 表单数据
const form = ref({
  timetype: 'y-m-d',
  ymd: new Date("January 01, 2020 00:00:00"),
  year: 2020,
  doy: 1,
  max_day: 365,
  hourtype: 'ut',
  lat: 0,
  lon: 0,
})
const disabledDate = (time) => {
  return (time.getTime() < new Date("January 01, 2003 00:00:00")) || (time.getTime() > new Date("November 26, 2022 00:00:00"))
}

// 重置表单变量
const ruleFormRef = ref()

// TITLE and TEC  
const title = ref('2020.001')
const tec = ref([[0, 0], [2, 0], [4, 0], [6, 0], [8, 0], [10, 0], [12, 0], [14, 0], [16, 0], [18, 0], [20, 0], [22, 0]])

// OPTION
let option = ref({
  xAxis: {
    name: 'Hour',
    nameLocation: 'middle',
    nameGap: 25,
    type: 'value',
    min: 0,
    max: 24,
    interval: 4,
    axisLabel: {
      fontSize: 16,
      fontFamily: 'Times New Roman',
    },
  },
  yAxis: {
    name: 'TEC',
    nameLocation: 'middle',
    nameGap: 30,
    nameRotate: 0,
    type: 'value',
    min: function (value) { return Math.floor(value.min) - 2 },
    max: function (value) { return Math.ceil(value.max) + 2 },
    axisLabel: {
      fontSize: 16,
      fontFamily: 'Times New Roman',
    },
  },
  title: {
    show: true,
    text: title,
    left: 'center',
    top: 20,
  },
  axisPointer: {
    show: true,
    type: 'line',
    snap: true,
    lineStyle: {
      type: 'dashed',
      color: 'purple',
    }
  },
  textStyle: {
    fontSize: 16,
    fontFamily: 'Times New Roman'
  },
  toolbox: {
    show: true,
    orient: 'horizontal',
    left: 'right',
    top: 'center',
    feature: {
      saveAsImage: { show: true }
    }
  },
  series: [
    {
      data: tec,
      type: 'line',
      symbol: 'circle',
      symbolSize: 12,
      grid: {
        show: true,
      },
      itemStyle: {
        color: '#e87254',
        borderColor: '#fff',
      },
      lineStyle: {
        color: '#2b2b2b'
      },
      connectNulls: false
    }
  ]
});


// -------------------------------------------------------------------------- //
// 检查时间
function checkyear() {
  if ((form.value['year'] % 4 == 0 && form.value['year'] % 100 != 0) || (form.value['year'] % 400 == 0)) {
    form.value['max_day'] = 366;
  } else {
    form.value['max_day'] = 365;
    if (form.value['doy'] > 365) {
      form.value['doy'] = 365
    }
  }
  if (form.value['year'] == 2022) {
    form.value['max_day'] = 330;
    if (form.value['doy'] > 330) {
      form.value['doy'] = 330
    }
  }
}

function checkdoy() {
  if (form.value['doy'] > form.value['max_doy']) {
    form.value['doy'] = form.value['max_doy']
  }
}

// 提交表单
function onSubmit() {
  let info = JSON.parse(JSON.stringify(toRaw(form.value)))
  axios.post('/get_tec_single', info)
    .then((res) => {
      let temp = res.data.tec
      let updatedtemp = temp.map(row => {
        let newRow = [row[0]];
        for (let i = 1; i < row.length; i++) {
          newRow.push(row[i] === -1 ? NaN : row[i]);
        }
        return newRow;
      });
      tec.value = updatedtemp
      title.value = res.data.time
      let myChart = echarts.getInstanceByDom(document.getElementById("ECharts_Single"))
      myChart.setOption(option.value);
    })
    .catch((err) => console.log(err))
}

// 重置表单
function reset() {
  ruleFormRef.value.resetFields();
  tec.value = [[0, 0], [2, 0], [4, 0], [6, 0], [8, 0], [10, 0], [12, 0], [14, 0], [16, 0], [18, 0], [20, 0], [22, 0]]
  let myChart = echarts.getInstanceByDom(document.getElementById("ECharts_Single"))
  myChart.setOption(option.value);
}

// 渲染绘图
function getRenderer() {
  var myChart = echarts.init(document.getElementById('ECharts_Single'));
  myChart.setOption(option.value);
}

// 生命周期
onMounted(() => {
  getRenderer()
})
</script>




<style scoped>
@media (max-width: 768px) {
  .mylayout {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    --el-font-size-base: 16px;
  }

  .mycharts {
    margin-left: 0px;
    display: inline-block;
    width: 300px;
    height: 250px;
  }
}

@media (min-width: 768px) {
  .mylayout {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    --el-font-size-base: 16px;
  }

  .mycharts {
    margin-left: 30px;
    display: inline-block;
    width: 600px;
    height: 400px;
  }
}

.el-form {
  padding: 10px;
  display: inline-block;
  border: 1.5px solid black;
}

.el-input-number {
  width: 140px;
  font-size: 16px;
}

.el-input {
  width: 60px;
  font-size: 16px;
}

.el-radio {
  margin: 0px;
}

.el-button {
  border-width: 1.5px;
  width: 108px;
}</style>
